<div class="min-h-screen bg-[#f6f7f9] font-nunito text-[#0e1726] antialiased dark:bg-[#060818] dark:text-white-light">
  <!-- ================================================================ TOPBAR -->
  <div role="banner" class="border-b border-black/[0.07] bg-white dark:border-white/[0.08] dark:bg-[#0e1726]">
    <div class="mx-auto flex max-w-[1560px] items-center gap-8 px-5 py-3.5 lg:px-10">
      <a routerLink="/home" class="shrink-0">
        <img src="assets/images/logo-22.png" alt="Pitzon" class="h-8 w-auto dark:hidden" />
        <img src="assets/images/logo-23.png" alt="Pitzon" class="hidden h-8 w-auto dark:block" />
      </a>

      <nav class="hidden items-center gap-1 lg:flex">
        <a routerLink="/home" class="rounded-lg px-3.5 py-2 text-[13px] font-bold text-[#0e1726] dark:text-white">Talleres</a>
        <a
          routerLink="/manage-vehicles"
          class="rounded-lg px-3.5 py-2 text-[13px] font-bold text-black/50 transition hover:text-black dark:text-white/50 dark:hover:text-white"
          >Mis vehículos</a
        >
        <a
          routerLink="/fleet/command-center"
          class="rounded-lg px-3.5 py-2 text-[13px] font-bold text-black/50 transition hover:text-black dark:text-white/50 dark:hover:text-white"
          >Flota</a
        >
      </nav>

      <div class="ml-auto flex shrink-0 items-center gap-2">
        <a
          routerLink="/app-download"
          class="hidden rounded-lg border border-black/15 px-4 py-2 text-[13px] font-bold transition hover:border-black/40 md:block dark:border-white/20 dark:hover:border-white/50"
        >
          Descarga la app
        </a>
        <button
          type="button"
          (click)="toggleTheme()"
          aria-label="Cambiar tema"
          class="flex h-9 w-9 items-center justify-center rounded-lg transition hover:bg-black/[0.05] dark:hover:bg-white/[0.07]"
        >
          <svg
            *ngIf="!isDark"
            viewBox="0 0 24 24"
            fill="none"
            class="h-[18px] w-[18px]"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" />
          </svg>
          <svg *ngIf="isDark" viewBox="0 0 24 24" fill="none" class="h-[18px] w-[18px]" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">
            <circle cx="12" cy="12" r="4.2" />
            <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.2 5.2l1.4 1.4M17.4 17.4l1.4 1.4M18.8 5.2l-1.4 1.4M6.6 17.4l-1.4 1.4" />
          </svg>
        </button>
        <button
          type="button"
          aria-label="Mi cuenta"
          class="flex h-9 w-9 items-center justify-center rounded-lg bg-[#0e1726] text-[12px] font-extrabold text-primary dark:bg-primary dark:text-black"
        >
          P
        </button>
      </div>
    </div>
  </div>

  <!-- ================================================================== HERO -->
  <section class="relative overflow-hidden bg-[#060818] text-white">
    <div class="pointer-events-none absolute -right-32 -top-40 h-[480px] w-[480px] rounded-full bg-primary/20 blur-3xl"></div>
    <div class="pointer-events-none absolute -bottom-52 left-[18%] h-[380px] w-[380px] rounded-full bg-[#ff5500]/20 blur-3xl"></div>

    <div class="relative mx-auto max-w-[1000px] px-5 py-14 lg:py-20">
      <span
        class="inline-flex items-center gap-2 rounded-md border border-primary/30 bg-primary/10 px-3 py-1 text-[11px] font-extrabold uppercase tracking-[0.18em] text-primary"
      >
        Red Pitzon
      </span>

      <h1 class="mt-5 max-w-[18ch] text-[34px] font-extrabold leading-[1.08] tracking-tight lg:text-[52px]">
        El taller correcto,<br />antes de que sea urgente.
      </h1>

      <p class="mt-4 max-w-[52ch] text-[15px] font-medium leading-relaxed text-white/55 lg:text-[16px]">
        Mecánica, latonería, motos, pesados y autolavado. Busca por especialidad, mira quién está más cerca y agenda desde la app.
      </p>

      <!-- Buscador: barra ancha, no píldora segmentada -->
      <div class="mt-8 flex w-full max-w-[680px] flex-col gap-2.5 sm:flex-row">
        <div
          class="flex flex-1 items-center gap-3 rounded-xl border border-white/15 bg-white/[0.06] px-5 py-3.5 transition focus-within:border-primary focus-within:bg-white/[0.09]"
        >
          <svg viewBox="0 0 24 24" fill="none" class="h-[18px] w-[18px] shrink-0 text-white/40" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
            <circle cx="11" cy="11" r="7" />
            <path d="m20 20-3.2-3.2" />
          </svg>
          <input
            type="text"
            [value]="query"
            (input)="onQueryChange($any($event.target).value)"
            placeholder="Nombre del taller o especialidad"
            class="w-full border-0 bg-transparent p-0 text-[15px] font-semibold text-white placeholder:font-medium placeholder:text-white/35 focus:outline-none focus:ring-0"
          />
        </div>
        <button
          type="button"
          (click)="scrollToResults()"
          class="shrink-0 rounded-xl bg-primary px-8 py-3.5 text-[15px] font-extrabold text-black transition hover:bg-primary-light"
        >
          Buscar
        </button>
      </div>

      <!-- Métricas reales del catálogo -->
      <div class="mt-10 flex flex-wrap gap-x-12 gap-y-5">
        <div>
          <span class="block text-[26px] font-extrabold leading-none text-primary">{{ loading ? '—' : totalWorkshops }}</span>
          <span class="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.16em] text-white/40">Talleres</span>
        </div>
        <div>
          <span class="block text-[26px] font-extrabold leading-none text-primary">{{ loading ? '—' : categories.length }}</span>
          <span class="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.16em] text-white/40">Especialidades</span>
        </div>
        <div>
          <span class="block text-[26px] font-extrabold leading-none text-primary">{{ loading ? '—' : photoCount }}</span>
          <span class="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.16em] text-white/40">Con fotos del local</span>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================== TOOLBAR -->
  <div class="sticky top-0 z-30 border-b border-black/[0.07] bg-white/95 backdrop-blur-xl dark:border-white/[0.08] dark:bg-[#0e1726]/95">
    <div class="mx-auto flex max-w-[1560px] items-center gap-3 px-5 py-3 lg:px-10">
      <!-- Chips sólidos de especialidad -->
      <div class="no-scrollbar flex flex-1 items-center gap-2 overflow-x-auto">
        <button type="button" (click)="selectCategory(null)" class="chip" [class.chip--on]="!activeCategory">Todos</button>
        <button
          *ngFor="let c of categories; trackBy: trackByCategory"
          type="button"
          (click)="selectCategory(c.name)"
          class="chip"
          [class.chip--on]="activeCategory === c.name"
        >
          <span>{{ c.icon + ' ' + c.short }}</span>
          <span class="chip__count">{{ c.count }}</span>
        </button>
      </div>

      <span class="hidden h-6 w-px shrink-0 bg-black/10 md:block dark:bg-white/10"></span>

      <button type="button" (click)="toggleWithPhoto()" class="chip hidden md:inline-flex" [class.chip--on]="onlyWithPhoto">Con foto</button>

      <button type="button" (click)="useMyLocation()" class="chip hidden shrink-0 md:inline-flex" [class.chip--on]="userLoc">
        <svg viewBox="0 0 24 24" fill="none" class="h-3.5 w-3.5" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="2.8" />
          <circle cx="12" cy="12" r="7.6" />
          <path d="M12 2.2v2.2M12 19.6v2.2M2.2 12h2.2M19.6 12h2.2" stroke-linecap="round" />
        </svg>
        {{ locating ? 'Ubicando…' : 'Cerca de mí' }}
      </button>

      <!-- Control segmentado lista / mapa -->
      <div class="seg shrink-0">
        <button type="button" (click)="setView('list')" class="seg-btn" [class.seg-btn--on]="!showMap">Lista</button>
        <button type="button" (click)="setView('map')" class="seg-btn" [class.seg-btn--on]="showMap">Mapa</button>
      </div>
    </div>
  </div>

  <!-- ================================================================== MAIN -->
  <main id="ptz-results" class="mx-auto max-w-[1560px] px-5 pb-24 pt-7 lg:px-10">
    <div class="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 class="text-[18px] font-extrabold tracking-tight lg:text-[21px]">
          <ng-container *ngIf="loading">Cargando la red de talleres…</ng-container>
          <ng-container *ngIf="!loading">{{ resultsTitle }}</ng-container>
        </h2>
        <p class="mt-0.5 text-[13px] font-medium text-black/45 dark:text-white/45">
          <ng-container *ngIf="userLoc">Ordenados por cercanía a tu ubicación</ng-container>
          <ng-container *ngIf="!userLoc && !locationDenied">Activa «Cerca de mí» para ordenarlos por distancia</ng-container>
          <ng-container *ngIf="!userLoc && locationDenied">No pudimos obtener tu ubicación — mostrando toda la red</ng-container>
        </p>
      </div>

      <button
        *ngIf="hasFilters"
        type="button"
        (click)="clearFilters()"
        class="flex items-center gap-1.5 rounded-lg border border-black/15 px-3.5 py-2 text-[12px] font-bold transition hover:border-black/40 dark:border-white/20 dark:hover:border-white/50"
      >
        <svg viewBox="0 0 24 24" fill="none" class="h-3.5 w-3.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round">
          <path d="m6 6 12 12M18 6 6 18" />
        </svg>
        Limpiar filtros
      </button>
    </div>

    <!-- ------------------------------------------------------------ cargando -->
    <div *ngIf="loading" class="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      <div *ngFor="let s of skeletons" class="overflow-hidden rounded-xl border border-black/[0.07] bg-white dark:border-white/10 dark:bg-[#0e1726]">
        <div class="ratio-photo shimmer"></div>
        <div class="p-4">
          <div class="shimmer h-3.5 w-3/4 rounded"></div>
          <div class="shimmer mt-2.5 h-3 w-1/2 rounded"></div>
          <div class="shimmer mt-4 h-12 w-full rounded-lg"></div>
        </div>
      </div>
    </div>

    <!-- ------------------------------------------------------------- grilla -->
    <div *ngIf="!loading && !showMap && visible.length">
      <div class="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        <ng-container *ngFor="let card of visible; trackBy: trackById">
          <ng-container *ngTemplateOutlet="cardTpl; context: { $implicit: card }"></ng-container>
        </ng-container>
      </div>

      <div *ngIf="canLoadMore" class="mt-10 flex flex-col items-center gap-3">
        <div class="h-1 w-56 overflow-hidden rounded-full bg-black/10 dark:bg-white/10">
          <div class="h-full rounded-full bg-primary transition-all duration-500" [style.width.%]="(visible.length / results.length) * 100"></div>
        </div>
        <p class="text-[12px] font-bold text-black/45 dark:text-white/45">{{ visible.length }} de {{ results.length }} talleres</p>
        <button
          type="button"
          (click)="loadMore()"
          class="rounded-xl border-2 border-[#0e1726] px-7 py-2.5 text-[13px] font-extrabold transition hover:bg-[#0e1726] hover:text-white dark:border-primary dark:text-primary dark:hover:bg-primary dark:hover:text-black"
        >
          Cargar más talleres
        </button>
      </div>
    </div>

    <!-- ---------------------------------------------------------------- mapa -->
    <div *ngIf="!loading && showMap && results.length" class="flex gap-5">
      <div class="no-scrollbar hidden w-[42%] shrink-0 overflow-y-auto lg:block" style="max-height: calc(100vh - 150px)">
        <div class="grid grid-cols-1 gap-4 pb-6 xl:grid-cols-2">
          <ng-container *ngFor="let card of visible; trackBy: trackById">
            <div (mouseenter)="selectCard(card)">
              <ng-container *ngTemplateOutlet="cardTpl; context: { $implicit: card }"></ng-container>
            </div>
          </ng-container>
        </div>
        <div *ngIf="canLoadMore" class="pb-8 text-center">
          <button type="button" (click)="loadMore()" class="rounded-xl border border-black/15 px-6 py-2.5 text-[13px] font-bold dark:border-white/20">
            Cargar más
          </button>
        </div>
      </div>

      <div class="relative flex-1 overflow-hidden rounded-xl border border-black/[0.07] dark:border-white/10" style="height: calc(100vh - 150px)">
        <google-map [center]="mapCenter" [zoom]="mapZoom" [options]="mapOptions" width="100%" height="100%">
          <map-marker
            *ngFor="let m of markers; trackBy: trackById"
            [position]="m.pos"
            [title]="m.name"
            [options]="markerOptions"
            (mapClick)="selectCard(m)"
          ></map-marker>
          <map-marker *ngIf="userLoc" [position]="userLoc" [options]="userMarkerOptions" title="Tu ubicación"></map-marker>
        </google-map>

        <div
          class="pointer-events-none absolute left-4 top-4 rounded-lg bg-[#0e1726] px-3.5 py-2 text-[11px] font-extrabold uppercase tracking-wide text-primary shadow-lg"
        >
          {{ markers.length }} de {{ results.length }} en el mapa
        </div>

        <div
          *ngIf="selected"
          class="absolute bottom-4 left-4 w-[300px] overflow-hidden rounded-xl border border-black/[0.07] bg-white shadow-2xl dark:border-white/10 dark:bg-[#0e1726]"
        >
          <button
            type="button"
            (click)="selected = null"
            aria-label="Cerrar"
            class="absolute right-2.5 top-2.5 z-10 flex h-7 w-7 items-center justify-center rounded-lg bg-[#0e1726]/85 text-white"
          >
            <svg viewBox="0 0 24 24" fill="none" class="h-3.5 w-3.5" stroke="currentColor" stroke-width="2.6" stroke-linecap="round">
              <path d="m6 6 12 12M18 6 6 18" />
            </svg>
          </button>
          <div class="h-[120px] w-full bg-black/[0.05] dark:bg-white/[0.06]">
            <img *ngIf="selected.image" [src]="selected.image" (error)="onImageError(selected)" [alt]="selected.name" class="h-full w-full object-cover" />
            <div
              *ngIf="!selected.image"
              class="flex h-full w-full items-center justify-center bg-gradient-to-br from-primary/30 via-primary/10 to-transparent text-4xl"
            >
              {{ selected.icons[0] || '🔧' }}
            </div>
          </div>
          <div class="p-3.5">
            <h3 class="clamp-1 text-[14px] font-extrabold">{{ selected.name }}</h3>
            <p class="clamp-1 mt-0.5 text-[12px] font-medium text-black/45 dark:text-white/45">{{ selected.categories.join(' · ') }}</p>
            <div class="metrics mt-3">
              <div>
                <b>{{ selected.rating | number: '1.1-1' }}</b
                ><span>Calificación</span>
              </div>
              <div>
                <b>{{ selected.reviews }}</b
                ><span>Reseñas</span>
              </div>
              <div>
                <b>{{ selected.distanceKm !== null ? formatDistance(selected.distanceKm) : selected.categories.length }}</b>
                <span>{{ selected.distanceKm !== null ? 'Distancia' : 'Servicios' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ------------------------------------------------------ sin resultados -->
    <div
      *ngIf="!loading && !results.length"
      class="flex flex-col items-center justify-center rounded-2xl border border-dashed border-black/15 py-20 text-center dark:border-white/15"
    >
      <span class="text-4xl">🔧</span>
      <h2 class="mt-4 text-[17px] font-extrabold">Ningún taller coincide con esos filtros</h2>
      <p class="mt-1.5 max-w-md text-[13.5px] font-medium text-black/45 dark:text-white/45">
        Cambia la especialidad o la búsqueda para volver a ver los {{ totalWorkshops }} talleres de la red.
      </p>
      <button type="button" (click)="clearFilters()" class="mt-6 rounded-xl bg-primary px-7 py-3 text-[14px] font-extrabold text-black">Limpiar filtros</button>
    </div>

    <!-- ------------------------------------------------------------- CTA app -->
    <section *ngIf="!showMap && !loading" class="relative mt-16 overflow-hidden rounded-2xl bg-[#0e1726] text-white">
      <div class="pointer-events-none absolute -right-20 -top-24 h-[320px] w-[320px] rounded-full bg-primary/15 blur-3xl"></div>
      <div class="relative flex flex-col items-start gap-8 px-8 py-11 lg:flex-row lg:items-center lg:justify-between lg:px-14 lg:py-14">
        <div class="max-w-xl">
          <span class="text-[11px] font-extrabold uppercase tracking-[0.18em] text-primary">Aquí encuentras · en la app registras</span>
          <h2 class="mt-3 text-[25px] font-extrabold leading-tight lg:text-[32px]">Tu carro tiene historia.<br />Llévala en el bolsillo.</h2>
          <p class="mt-3 text-[14.5px] font-medium leading-relaxed text-white/60">
            Anota tanqueos y mantenimientos al salir del taller, recibe alertas de SOAT y tecnomecánica, y agenda tu próxima cita.
          </p>
        </div>
        <a routerLink="/app-download" class="shrink-0 rounded-xl bg-primary px-8 py-4 text-[15px] font-extrabold text-black transition hover:bg-primary-light"
          >Descargar la app</a
        >
      </div>
    </section>
  </main>
</div>

<!-- ============================================================ TARJETA (tpl) -->
<ng-template #cardTpl let-card>
  <article
    class="group flex h-full flex-col overflow-hidden rounded-xl border border-black/[0.07] bg-white transition duration-300 hover:-translate-y-1 hover:border-black/15 hover:shadow-[0_14px_34px_rgba(14,23,38,.14)] dark:border-white/10 dark:bg-[#0e1726] dark:hover:border-white/25"
  >
    <div class="ratio-photo relative overflow-hidden bg-black/[0.05] dark:bg-white/[0.06]">
      <img
        *ngIf="card.image"
        [src]="card.image"
        [alt]="card.name"
        loading="lazy"
        (error)="onImageError(card)"
        class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.05]"
      />
      <div *ngIf="!card.image" class="flex h-full w-full items-center justify-center bg-gradient-to-br from-primary/30 via-primary/10 to-transparent">
        <span class="text-[42px] opacity-70">{{ card.icons[0] || '🔧' }}</span>
      </div>

      <!-- Etiqueta de especialidad anclada a la foto -->
      <span class="absolute bottom-2.5 left-2.5 rounded-md bg-primary px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wide text-black">
        {{ (card.icons[0] || '🔧') + ' ' + categoryShort(card) }}
      </span>

      <span
        *ngIf="card.verified"
        class="absolute left-2.5 top-2.5 flex items-center gap-1 rounded-md bg-[#0e1726]/85 px-2 py-1 text-[10px] font-extrabold uppercase tracking-wide text-primary backdrop-blur"
      >
        <svg viewBox="0 0 24 24" fill="none" class="h-3 w-3" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m5 12.5 4.5 4.5L19 7.5" />
        </svg>
        Verificado
      </span>
    </div>

    <div class="flex flex-1 flex-col p-4">
      <div class="flex items-start justify-between gap-2">
        <h3 class="clamp-2 text-[14.5px] font-extrabold leading-snug">{{ card.name }}</h3>
        <button
          type="button"
          (click)="toggleFavorite(card, $event)"
          [attr.aria-label]="isFavorite(card) ? 'Quitar de guardados' : 'Guardar taller'"
          class="-mr-1 -mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg transition hover:bg-black/[0.06] dark:hover:bg-white/[0.08]"
        >
          <svg
            viewBox="0 0 24 24"
            class="h-[17px] w-[17px]"
            [attr.fill]="isFavorite(card) ? '#c5f112' : 'none'"
            stroke="currentColor"
            stroke-width="1.9"
            stroke-linejoin="round"
          >
            <path d="M6.5 3.5h11a1 1 0 0 1 1 1v16l-6.5-4-6.5 4v-16a1 1 0 0 1 1-1Z" />
          </svg>
        </button>
      </div>

      <p class="clamp-1 mt-1 text-[12px] font-medium text-black/45 dark:text-white/45">{{ card.categories.join(' · ') }}</p>

      <!-- Panel de métricas: la firma visual de Pitzon, no una línea de texto -->
      <div class="metrics mt-auto pt-3.5">
        <div>
          <b>{{ card.rating | number: '1.1-1' }}</b>
          <span>Calificación</span>
        </div>
        <div>
          <b>{{ card.reviews }}</b>
          <span>Reseñas</span>
        </div>
        <div>
          <b>{{ card.distanceKm !== null ? formatDistance(card.distanceKm) : card.categories.length }}</b>
          <span>{{ card.distanceKm !== null ? 'Distancia' : 'Servicios' }}</span>
        </div>
      </div>
    </div>
  </article>
</ng-template>
